import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { ADD_FORM_NAME, ADD_PARTICIPANTS_FORM_NAME } from 'presentations/constants';
import ParticipantMsgPreview from 'presentations/components/participant_msg_preview';

const mapStateToProps = (state) => {
  const { project } = state;
  /* get list of selected revisions based on active form */
  const selector = formValueSelector(
    project.presentations.showingAddModal? ADD_FORM_NAME : ADD_PARTICIPANTS_FORM_NAME
  );
  /* only the form values that will be used in the component */
  const { invite_message, first_name, last_name } = selector(
    state, 'invite_message', 'first_name', 'last_name'
  );

  return {
    fullName: (first_name || last_name)? `${first_name} ${last_name}` : 'YOUR NAME',
    message: invite_message
  };
}

export default connect(mapStateToProps)(ParticipantMsgPreview);



// WEBPACK FOOTER //
// ./presentations/containers/participant_msg_preview.js